import type { HardwareSelectorDialogConfig } from './HardwareSelectorCore'

/**
 * Multi-select mode (quantity controls + Done footer + dialog stays open after each pick)
 * is **opt-in** via `config.multiSelect`. It must not be inferred from `targetUuids`:
 * empty or missing targets are used for many single-step flows (e.g. slot add, deferred DC optimiser apply).
 */
export const isMultiSelectMode = (config: HardwareSelectorDialogConfig): boolean => {
  return config.multiSelect === true
}
